const warehouse = {
  inventoryOrderList: 'Purchase Order Inbound',
  orderNumber: 'Order Number',
  documentNumber: 'Document Number',
  changeType: 'Change Type',
  lot: 'Batch',
  quantity: 'Quantity',
  totalIn: 'Total Inbound',
  totalOut: 'Total Outbound',
  inventory: 'Inventory',
  balance: 'Balance',
  plSelectProduct: "Please select product",
  plProductNum: "Please enter product quantity",
  productNumMin: "Product quantity minimum is {{ num }}",
  addProduct: "Add product information",
  addProductForm: "Fill out {{ name }} form",

  inbound: 'Inbound',
  outbound: 'Outbound',

  deliveryOrderNumber: 'Delivery (Inbound) Order Number',
  materialRequisitionNumber: 'Material Requisition (Outbound) Order Number',

  inboundOprt: 'I want to inbound',
  outboundOprt: 'I want to outbound',
  outboundError: 'Outbound failed',
  outboundSuccess: 'Outbound successful',
  insufficientInventory: 'Insufficient inventory',
  forceOutbound: 'Force outbound?',
  forceOutboundFailed: 'Force outbound failed',
  inboundError: 'Inbound failed',
  outboundNotEnough: 'Insufficient inventory quantity',
  returnStock: 'Return Stock',
  returnStockSuccess: 'Return stock successful',
  returnStockFail: 'Return stock failed',
  returnQuantity: 'Return quantity',
  selectLocationToReturn: 'Select location to return',
  selectLocationToInbound: 'Select inbound location',
  available: 'Available',
  returnExceedsAvailable: 'Return quantity exceeds available quantity',
  returnExceedsOriginal: 'Return quantity exceeds original order quantity {{original}}',
  validationError: 'Validation failed',
  sourcesPick: 'Material Pick',
  pickingOutbound: 'Picking Outbound',
  sourcesInReturn: 'Inbound Order Return',
  sourcesOutReturn: 'Outbound Order Return',

  numDetail: 'Quantity Entry Detail',
  productNum: 'Product Quantity',

  arrivalAt: 'Arrival Time',
  remark: 'Remark',
  enterRemark: 'Please enter remark',
  requiredArrivalAt: 'Required Arrival Time',
  actualArrivalAt: 'Actual Arrival Time',
  plArrivalAt: 'Please enter arrival time',
  startTime: 'Start Time',
  endTime: 'End Time',
  deliveryStartTime: 'Delivery Start Time',
  deliveryEndTime: 'Delivery End Time',
  plProduct: 'Please select product',
  inQuantity: 'Inbound Quantity',
  plInQuantity: 'Please enter inbound quantity',
  outQuantity: 'Outbound Quantity',
  plOutQuantity: 'Please enter outbound quantity',
  codeRepeat: 'Barcode duplicate, please delete and try again',
  orderType: 'Inbound Order Type',
  inOrder: 'Inbound Order',
  preInOrder: 'Delivery Order Inbound (Pre-inbound)',
  purchaseOrder: 'Purchase Order',
  selectOrderType: 'Please select inbound order type',
  selectOrderNumber: 'Please enter inbound order number',
  numberNotExist: 'Order number does not exist',
  orderConfirmed: 'This order has been confirmed',
  purchaseNotPass: 'Purchase not approved',
  saveOrder: 'Save inbound order',
  orderSuccess: 'Inbound successful',
  code: 'Barcode',
  existCode: 'Already exists',
  deleteBarcode: 'Confirm delete barcode?',
  deleteBarcodeSuccess: 'Delete successful',
  clearCode: 'Confirm clear barcodes?',
  clear: 'Clear barcodes',
  existBarcode: 'Entered barcodes:',
  outboundType: 'Outbound Type',
  inboundType: 'Inbound Type',
  preOutOrder: 'Material Requisition Outbound (Pre-outbound)',
  outSuccess: 'Outbound successful',
  tempIn: 'Temporary Inbound',
  tempOut: 'Temporary Outbound',
  preIn: 'Pre-inbound Quantity',
  preOut: 'Pre-outbound Quantity',
  product: 'Product',
  salesOrder: 'Sales Order',
  outOrder: 'Outbound Order',
  specialOutbound: 'Special Material Outbound (Requirement List)',
  exportExcel: 'Export Excel',
  packingExportConfirm: 'Are you sure you want to export the sorting list?',
  specialMaterialList: 'Special Material List',
  specialOutSuccess: 'Special material outbound successful',
  specialOutFail: 'Special material outbound failed',
  normalMaterialList: 'Common Inventory List',
  count: 'Inventory Quantity',
  thirdPartyBatch: 'Supplier Batch Number',

  inOK: "Inbound successful",
  outOK: "Outbound successful",
  inFail: "Inbound failed",
  outFail: "Outbound failed",

  // Inventory Management
  materialList: 'Material List',
  locationList: 'Location List',
  realMaterialList: "Available Stock",
  locationCode: 'Location Code',
  searchMaterialPlaceholder: 'Search material code/name',
  searchLocationPlaceholder: 'Search location code',
  searchBatchPlaceholder: 'Search batch number/supplier batch number',
  searchMultiCodePlaceholder: 'Search inventory codes (separate multiple with spaces)',
  batchList: 'Batch List',
  materialDetail: 'Material Detail',
  lotCount: 'Batch Count',
  locationDetail: 'Location Detail',
  barcodeList: 'Barcode List',
  state: 'Status',
  lotItemLocationId: 'Batch Location ID',
  viewBarcode: 'View Barcode',
  batchNo: 'LOT',
  deliveryBatchNo: 'Delivery LOT',
  supplierBatchNo: 'Supplier LOT',
  labels: 'Labels',
  addLocation: 'Add Location',
  editLocation: 'Edit Location',
  locationIndex: 'Location Index',
  label1: 'Label 1',
  label2: 'Label 2',
  label3: 'Label 3',
  label4: 'Label 4',
  label5: 'Label 5',
  locationDescPlaceholder: 'Please enter location description',
  addLocationSuccess: 'Add location successful',
  addLocationFailed: 'Add location failed',
  updateLocationSuccess: 'Update location successful',
  updateLocationFailed: 'Update location failed',
  l1Required: 'L1 cannot be empty',
  l2Required: 'L2 cannot be empty',
  l3Required: 'L3 cannot be empty',
  l4Required: 'L4 cannot be empty',
  l5Required: 'L5 cannot be empty',
  l1RequiredFirst: 'Please fill L1 first',
  l2RequiredFirst: 'Please fill L2 first',
  l3RequiredFirst: 'Please fill L3 first',
  l4RequiredFirst: 'Please fill L4 first',

  // New i18n configurations
  location: 'Location',
  locationLabel: 'Location Label',
  selectLocation: 'Select Location',
  searchLocation: 'Search Location',
  locationExist: 'This location already exists',
  editBarcodes: 'Edit Barcodes',
  fetchError: 'Failed to fetch data',
  barcodesExceedCount: 'Barcode count cannot exceed location count',
  checkBarcodes: 'Please check barcodes',
  barcodesExceedNewCount: 'Barcode count exceeds the new location count, please adjust barcodes first',
  barcodesAutoTrimmed: 'Barcodes auto trimmed',
  barcodesAutoTrimmedDesc: 'Barcode count exceeds location count, automatically retained first {{count}} barcodes',
  totalExceedItemCount: 'Total quantity exceeds limit',
  totalExceedItemCountDesc: 'Location total quantity {{current}} exceeds order item quantity {{total}}',
  cannotAddLocation: 'Cannot add location',
  totalReachedItemCount: 'Location total quantity has reached order item quantity {{total}}',
  inboundSuccess: 'Inbound successful',
  inboundFailed: 'Inbound failed',
  quantityMismatch: 'Quantity mismatch',
  quantityMismatchDesc: 'The sum of location quantities for the following products does not match the order quantity:',
  currentTotal: 'Current Total',
  requiredTotal: 'Required Total',
  changeLocation: 'Change Location',
  partialInboundSuccess: 'Partial inbound successful',
  removeOldLocationsFailed: 'Failed to clear old location data',
  barcodeCount: 'Barcode Count',
  someItemsInboundFailed: 'Some products inbound failed',
  inboundResultDetail: '{{success}} products inbound successful, {{failed}} products inbound failed',
  failedItems: 'Failed Products',
  noBarcodes: 'No barcode data',

  outNo: "Outbound Order No",
  innerNo: "Internal Order No",
  outData: "Outbound Date",
  outWare: "Outbound Warehouse",
  llorg: "Picking Department",
  llper: "Picker",
  documentType: "Document Type: ",
  outper: "Outbound Operator",
  inper: "Inbound Operator",
  wareper: "Warehouse Manager",
  outCheckDate: "Audit Date",

  returnRn: "Return Reason: ",
  surplus: "Normal Balance Return",
  defective: "Defective Product Return",
  refurbished: "Defective Product Processing",
  forceReturn: "Confirm return stock?",
  barcodeErr: "Barcode error",
  forceInbound: "Force inbound?",
  forceInboundFailed: "Force inbound failed",
  forcedErr: "Force inbound failed",
  moveLoc: "Move Location",
  targetLocation: "Target Location",
  moveCount: "Move Count",
  maxMoveCount: "Max Move Count",
  moveFail: "Move failed",
  moveCurTip: "Target location cannot be the same as current location",
  pleaseSelectLocation: "Please select location",
  pleaseInputCount: "Please enter quantity",
  countExceedMax: "Quantity exceeds maximum value",
  reoutrecvdpicking: "Mistaken Outbound Picking",

  locationIndexExsist: 'Location index: {{index}} already exists',

  // Location Outbound
  locationOutbound: "Location Outbound",
  outNum: "Outbound Quantity",
  outBarcodes: "Outbound Barcodes",
  selectBarcode: "Select Barcode",
  confirmOutboundTip: "Confirm outbound?",
  confirmOutboundDesc: "Are you sure you want to perform outbound operation on the selected batch?",
  inventoryMismatch: "Inventory data mismatch, please verify data",

  // Barcode and Scan Sheet Related
  unsavedData: "There is unsaved data",
  cancelWithoutSave: "After cancellation, data cannot be recovered",
  confirmDeleteBarcode: "Are you sure you want to delete the barcode?",
  deleteCannotRecover: "After deletion, data cannot be recovered",
  confirmDeleteScanSheet: "Are you sure you want to delete the scan sheet?",
  scanSheet: "Scan Sheet",
  completeScanSheetInbound: "Complete scan sheet, confirm inbound",
  barcodesNotInOriginal: "The following barcodes do not exist in the original barcode list: {{barcodes}}",
  barcodeDuplicateInLocations: "Barcode {{barcode}} is duplicated in {{locationCodes}}",

  // Barcode Generation Related
  validationFailed: "Validation failed",
  dataInvalid: "Data invalid, scan sheet data cannot exceed {{max}}",
  generateFailed: "Generation failed",
  maxBarcodeCount: "Maximum barcode count limit {{count}} reached",
  batchGenerateBarcodes: "Batch Generate Barcodes",
  optional: "Optional",

  // Return Stock Related
  returnStockModal: "Return Stock",
  orderList: "Order List",
  leastOneMove: "At least one batch move count is greater than 0",
  confirmPreOut: "Confirm to execute pre-outbound?",
  sign: "Sign for",
  signed: "Signed",
  signSucc: "Sign successful",
  signFail: "Sign failed",
  plSignDate: "Select sign date",
  productRef: "Product Recommendation",
  selectProduct: "Select Product",
  productExists: "Product already exists",
  addLocationRef: "Add Location Product Association",
  confirmBatchDelete: "Are you sure you want to batch delete the selected location product associations?",
  confirmDeleteItem: "Are you sure you want to delete this location product association?",
  allocatePreOut: "Allocate Pre-outbound",
  allocatePreOutSuccess: "Allocate pre-outbound successful",
  allocatePreOutFail: "Allocate pre-outbound failed",

  // Manual Inbound Related
  manualInbound: "Manual Inbound",
  complete: "Complete",
  delete: "Delete",
  productCode: "Product Code",
  productName: "Product Name",
  productModel: "Product Model",
  uom: "UOM",
  noData: "No Data",
  previous: "Previous",
  next: "Next",
  confirm: "Confirm",
  notRecommendedLocation: "The selected location is not a recommended location",
  isNotRef: "This location is not the recommended location",
  recommendedLocations: "Recommended Locations",
  allLocations: "All Locations",
  locationsRequired: "Please add locations for each product",
  locationCountRequired: "Location count cannot be empty or 0",
  inboundComplete: "Inbound Complete",
  inboundSuccessDesc: "Inbound operation completed successfully",
  otherOut: "Other Outbound",
  outNumNotZ: "Outbound quantity cannot be 0",
  outNumExceedStock: "Outbound quantity exceeds available stock",
  productInput: "Enter Material",
  locNumnotOrder: "Total location quantity does not match inbound quantity, please modify",
  outOvernum: "Outbound quantity exceeds by {{num}} unit(s)",
  outLossnum: "Outbound quantity missing {{num}} unit(s)",
  outboundLocationError: "The following materials have no outbound location",
  outboundCountMismatch: "The outbound quantity for the following materials does not match the quantity to be outbound, please modify the data",
  noStock: "No Stock",
  delOutTip: "Pre-outbound order {{number}} has been generated. Delete it?",
  inputer: "Order Creator",
  confirmer: "Confirmer",
  locFailed: "Location information does not match order information. Please check.",
  reMatchTip: "Outbound confirmation failed, need to re-match inventory",
  reMatchSucc: "Location has been reassigned and data updated",
  reMatchFail: "Failed to re-match inventory",
  delInTip: "Pre-inbound order {{number}} has been generated. Delete it?",
  delInSucc: "Pre-inbound order {{number}} generated successfully",
  inboundUpdateSucc: "Pre-inbound order data updated",
  delOrderClose: "Delete Order",
  notDelClose: "Keep Order",
  needPrefit: 'Pre-check failed. The outbound batch information below needs to be corrected.',
  needSucc: 'Pre-check successful. Outbound data requires no correction.',
  needFail: 'Pre-check failed. Failed to retrieve inventory information.',
  outPrefit: 'Outbound Pre-check',
  fixOut: 'Modify Outbound',
  fixSucc: 'Outbound information modified successfully!',
  fixFail: 'Failed to modify outbound information!',
  outQtyErr: 'Outbound quantity allocation error!',
  fetchStockError: 'Failed to retrieve stock!',
  oldItemInfo: 'Original Outbound Information',
  returnInfo: 'Return to Stock Order Information',
  delReturnClose: "Return to stock order {{number}} has been generated. Delete it?",
  confirmReturnTip: "Confirm return to stock?",
  returnNumber: "Return to Stock Order Number",
  noUseStock: "No available stock",
  noLotStock: "No stock for this return batch: {{lot}}",
  noCodeStock: "No stock for this material: {{code}}",
  returnLot: "Return Batch",
  needFix: "Outbound confirmation failed. Please perform outbound pre-check and correct outbound information or reallocate stock.",
  rePreout: "Reallocate Stock",
  orderCount: "Current Outbound Quantity",
  useAmtReq: "Total Required Quantity",
  pickingOutbound_m: "Material Outbound",
  productOldCount: "Mat-Qty No-Conf",
  productNewCount: "Mat-Qty Conf",
  lotItemOldCount: "LOT-Qty No-Conf",
  lotItemNewCount: "LOT-Qty Conf",
  noconf: "Not Confirmed",
  confed: "Confirmed",
  plconfed: "Is it confirmed?",
  refNo: "Reference No.",
  proIn: "Production Inbound",
  locProNot: "Insufficient stock: Location: {{locIdx}}, Material {{proCode}}",
  signTime: "Signing Time",
  prodTempIn: "Production Inbound (Temporary)",
  iqcState: "QC Status",
  notIqc: "Not QCed",
  iqcEd: "QCed",
  iqcCheck: "IQC Check",
  iqcList: "IQC Order List",
  iqcNumber: "QC Order No.",
  iqcInventory: "In/Out Order No.",
  iqcType: "QC Type",
  iqcUser: "Inspector",
  iqcRes: "QC Result",
  iqcTime: "QC Time",
  toQc: "Pending Inspection",
  qcIng: "Inspecting",
  passQc: "Passed",
  failQc: "Failed",
  front: "Appearance Defect",
  size: "Dimension Defect",
  power: "Performance Defect",
  package: "Packaging Defect",
  tag: "Labeling Defect",
  other: "Other",
  dispReturn: "Return",
  dispAcpt: "Concession Acceptance",
  dispRedo: "Rework",
  qcInbound: "Inbound QC",
  qcOutbound: "Outbound QC",
  qcWarehouse: "Stock QC",
  qcProgress: "In-Process QC",
  qcReturn: "Return QC",
  typePl: "Please select QC type",
  statePl: "Please select QC status",
  fetchErr: "Failed to get QC order!",
  createdAt: "Order Creation Time",
  creator: "Order Creator",
  desc: "QC Remarks",
  qcItems: "QC Items",
  checkCount: "QC Quantity",
  passCount: "Passed Quantity",
  failCount: "Failed Quantity",
  qcResult: "QC Result",
  defectType: "Defect Type",
  disposition: "Disposition Result",
  doc: "QC Attachment",
  remarks: "Remarks",
  qcItemList: "QC Material List",
  addQc: "Add QC Order",
  qcOrder: "QC Order",
  selectInventory: "Select In/Out Order",
  writeQc: "Fill QC Info",
  itemCount: "Order Quantity",
  descPl: "Enter QC remarks",
  checkCountPl: "Enter QC quantity",
  passCounPl: "Enter passed quantity",
  failCountPl: "Enter failed quantity",
  qcResultPl: "Select QC result",
  defectTypePl: "Select defect type",
  dispositionPl: "Select disposition result",
  qcTyePl: "Select QC type",
  add: "Generate QC Order",
  addErr: "Failed to generate QC order, no data",
  addErr1: "Failed to generate QC order",
  done: "Complete",
  doneTip: "QC order {{number}} has been successfully generated!",
  itemDesc: "Please enter remarks for QC item",
  noUpdate: "No data to update, no need to save",
  updateSucc: "Save successful",
  havePass: "Passed",
  notPass: "Failed to pass!",
  hasUpdata: "Unsaved changes exist. Save before passing?",
  canNotPass: "Failed to complete",
  canNotPassTip: "Please ensure all QC items have results",
  qcDone: "QC for {{number}} completed",
  reQc: "Re-inspect",
  doneQC: "Complete QC",
  optSucc: "Operation successful",
  optFail: "Operation failed",
  canAddQc: "You can continue adding QC orders",
  orderQcDone: "In/Out Order: {{number}} QC completed [{{res}}]",
  normalPrint: "Horizontal Paginated",
  verticalPrint: "Vertical Continuous",
  manual: "Manual",
  production: "Production",
  purchase: "Purchase",
  sale: "Sale",
  dispose: "Allocation",
  sourceType: "Type",
  packing: "Warehouse Sorting",
  packingNo: "Sorting List No.",
  perBoxQuantity: "Quantity/Box",
  perBoxNetWeight: "Net Weight/Box",
  perBoxGrossWeight: "Gross Weight/Box",
  totalQuantity: "Quantity",
  totalNetWeight: "Net Weight",
  totalGrossWeight: "Gross Weight",
  measurements: "Measurements",
  packingVolume: "Volume",
  draft: "Draft",
  confirmed: "Confirmed",
  shuted: "Sealed",
  wasted: "Voided",
  packStatus: "Sorting Status",
  totalBoxes: "Total Boxes",
  grossWeight: "Gross Weight",
  netWeight: "Net Weight",
  totalVolume: "Volume",
  delTip: "Are you sure you want to void sorting list: {{no}}?",
  addPack: "Add Sorting List",
  inventoryPl: "Please select an outbound order",
  inventoryInPl: "Please select an inbound order",
  orderPl: "Please select an in/out order",
  packDtl: "Sorting List Details",
  closeBox: "Seal",
  openBox: "Unseal",
  killed: "Void",
  confirmSucc: "Confirmation successful",
  confirmFail: "Confirmation failed",
  sealSucc: "Seal successful",
  sealFail: "Seal failed",
  unSealSucc: "Unseal successful",
  unSealFail: "Unseal failed",
  wasteFail: "Void failed",
  items: "Items",
  boxes: "Sorting Details",
  boxNo: "Box No.",
  boxBarcode: "Box Barcode",
  lengthMm: "Length (cm)",
  widthMm: "Width (cm)",
  heightMm: "Height (cm)",
  volumeCbm: "Volume (cm³)",
  grossWeightG: "Gross Weight (kg)",
  netWeightG: "Net Weight (kg)",
  packageType: "Package Type",
  marksNumbers: "Marks & Numbers",
  delBoxTip: "Are you sure you want to delete: {{no}}?",
  addBox: "Add Box",
  editBox: "Edit Box {{no}}",
  boxAddItem: "Sort",
  boxedCount: "Sorted Quantity",
  plItem: "Please select item to sort",
  boxEditItem: "Modify Sorting Info",
  boxItemQty: "Sorted Quantity",
  declaredUnitPrice: "Unit Price",
  declaredCurrency: "Currency",
  hsCode: "HS Code",
  originPlace: "Origin",
  productNameCn: "Chinese Name",
  productNameEn: "English Name",
  brand: "Brand",
  brandType: "Brand Type",
  packingModel: "Model",
  packingOrigin: "Origin",
  exportBrandName: "Export Brand Name",
  declaredAmount: "Total Amount",
  shutErr: "Seal failed",
  weightNeed: "Please fill in gross weight and net weight",
  shipmentOut: "Ship Out",
  noShipment: "Shipment not found",
  noOrder: "Order not found",
  outItems: "Outbound Details",
  plPreLOcTypes: "Please select outbound matching location type",
  shipOutData: "Shipping Outbound Data",
  outDone: "Outbound Completed",
  noBox: "No boxes or boxes are empty!",
  needPre: "Please allocate stock for the shipping outbound order first",
  selectSaleOrder: "Select Sales Order",
  noOutOrder: "No Outbound Order",
  noOutOrderTip: "No confirmed outbound orders",
  outOrderFail: "Failed to load outbound orders",
  selectOutOrder: "Select Outbound Order",
  remainPack: "Remaining Sorting Quantity",
  selectLot: "Select Batch",
  genShip: "Generate Shipping Order",
  searchCode: "Search Material Code",
  plSelBox: "Please select the boxes to ship",
  plInQuantityLot: "Please enter inbound quantity and lot",
  packOrder: "Sorting List",
  toClose: "Pending Seal",
  gWeightNeed: "Please enter gross weight",
  addOutOrder: "Add Outbound Order",
  sealAllTip: "All boxes in the sorting list are sealed. After confirmation, the entire order will be automatically sealed.",
  emptyBox: "Empty boxes: {{number}}",
  selectCustomer: "Select Customer",
  selectCustomerPl: "Please select customer",
  multiBox: "Multi-Box Entry",
  addingTip: "Please enter the number of boxes (including current box)",
  addPackQty: "Number of Boxes",
  newBoxNumber: "New Box No.",
  selBoxErr: "Invalid selection",
  selBoxErrTip1: "Only sealed boxes that have not generated a shipping order can be selected",
  selBoxErrTip2: "Cannot select empty boxes or boxes that have already been sealed",
  selBoxErrTip3: "The following boxes have been filtered out",
  batchSeal: "Batch Seal",
  plBatchSeal: "Please select boxes to seal",
  batchGross: "Apply gross weight in batch (once checked, gross weight will be updated for all current boxes)",
  batchSealSucc: "Batch seal successful",
  batchSealErr: "Batch seal failed",
  editBoxErr: "Failed to modify box weight, Box No.: {{number}}",
  sealBoxErr: "Failed to seal box, Box No.: {{number}}",
  filterdSeal: "Sealed boxes and empty boxes have been ignored",
  noSealBox: "No boxes available for sealing",
  sealRange: "Seal Range",
  boxNoPl: "Please enter box number",
  reset: "Reset",
  startNo: "Start Box No.",
  endNo: "End Box No.",
  searchRange: "Search Range",
  productType: "Product Type",
};

export default warehouse;
